export const DEV = 'dev';
export const QA = 'qa';
export const PREPROD = 'preprod';
export const TESTNET = 'testnet';
export const PRODUCTION = 'production';
export const CN = 'cn';
export const GLOBAL = 'global';

export const SETTING_KEYS = {
  LANGUAGE: 'language',
  CURRENCY: 'nativeCurrency',
};

export const AUTH_TYPE = {
  BOTH: 'both',
  GOOGLE: 'google',
  SMS: 'sms',
};
